import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { normalizeList } from '../../../common/package/list';
import { projectKeys } from '../queries/keys';
import { projectPaths } from '../queries/paths';
import { normalizePlan, normalizeProject, normalizeProjectDetail } from '../utils/normalize';

export function useProjectsList({ q, state, limit = 50 } = {}) {
    const params = { limit };
    if (q) params.q = q;
    if (state) params.project_state = state;
    return useQuery({
        queryKey: projectKeys.list(params),
        queryFn: async ({ signal }) => normalizeList((await api.get(projectPaths.list(), { params, signal })).data, normalizeProject),
        placeholderData: keepPreviousData,
    });
}

export function useProject(id) {
    return useQuery({
        queryKey: projectKeys.detail(id),
        queryFn: async ({ signal }) => normalizeProjectDetail((await api.get(projectPaths.detail(id), { signal })).data),
        enabled: id != null,
    });
}

export function useProjectPlans(projectId) {
    return useQuery({
        queryKey: projectKeys.plans(projectId),
        queryFn: async ({ signal }) => normalizeList(
            (await api.get(projectPaths.plans(), { params: { project_id: projectId, limit: 25 }, signal })).data,
            normalizePlan,
        ),
        enabled: projectId != null,
    });
}
